<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0012 13.2787L5.65453 8.93208C5.1412 8.41875 5.1412 7.57875 5.65453 7.06542L10.0012 2.71875" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>